import { FormikSelect, Hint } from '@elotech/components';

import { EnumAutocomplete } from '../../type';
import { useEnumValues } from '../../hooks/useEnumValues';

type FactoryProps = {
  enumClassName: string;
  baseUrl?: string;
};

// eslint-disable-next-line prettier/prettier
export type EnumAutoCompleteProps = Omit<React.ComponentProps<typeof FormikSelect<string>>, 'getOptionLabel' | 'getOptionValue' | 'options'>;

type Props = FactoryProps & EnumAutoCompleteProps;

export const EnumSearchFactory = ({
  enumClassName,
  baseUrl = '/api',
  noLabel,
  onSelect,
  ...props
}: Props) => {
  const options = useEnumValues(enumClassName, baseUrl);

  const doSelect = event => {
    props.onChange?.(event);

    const value = options.find(
      (option: EnumAutocomplete) =>
        option.codigo === event.target.value
    )?.codigo;

    onSelect?.(value!);
  };

  return (
    <div className="form-group">
    {!noLabel && (
      <label className="label" htmlFor={props.id || props.name}>
        {props.label}
        {props.hint && (
          <Hint
            classes={`inline clean module-color fa-exclamation-circle mobile sm ${props.hintClass}`}
          >
            {props.hint}
          </Hint>
        )}
      </label>
    )}
    <select
      key={`${baseUrl}-${enumClassName}-${options?.length}`}
      id={props.name}
      {...props}
      onChange={doSelect}
    >
      <option value={props.noValue || ''}>
        {props.defaultOptionLabel ?? 'Selecione'}
      </option>
      {options.map((option, index) => (
        <option key={index} value={option.codigo}>
          {option.descricao}
        </option>
      ))}
    </select>
    </div>
  );
};
